
const digest = '40a70066a058c59b27ab293bb0d438e0bbc94ca29b217ef1f72a49dae549d5eb';
const classes = {"wrapper":"_wrapper_tuxvk_1","header":"_header_tuxvk_5"};
const css = `._wrapper_tuxvk_1 {
  display: flex;
  flex-direction: column;
}
._wrapper_tuxvk_1 ._header_tuxvk_5 {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  